import LoginRepositoryEgi from 'egi/repositories/LoginRepositoryEgi'

export class LoginEGIService {
  async ssoLogin (body: Partial<{ ssoToken: string }>) {
    return LoginRepositoryEgi.ssoLogin(body)
  }
}
